
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { SortColumn, SortDirection } from "@/utils/types/componentTypes";

interface ComponentsTableHeaderProps {
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
}

export function ComponentsTableHeader({
  sortColumn,
  sortDirection,
  onSort,
}: ComponentsTableHeaderProps) {
  return (
    <TableHeader>
      <TableRow className="border-b border-border">
        <TableHead 
          className="font-semibold text-muted-foreground cursor-pointer hover:text-foreground" 
          onClick={() => onSort("name")}
        >
          Nome
        </TableHead>
        <TableHead 
          className="font-semibold text-muted-foreground cursor-pointer hover:text-foreground"
          onClick={() => onSort("component_type_name")}
        >
          Tipo
        </TableHead>
        <TableHead 
          className="font-semibold text-muted-foreground cursor-pointer hover:text-foreground"
          onClick={() => onSort("code_changes_7days")}
        >
          Mudanças Código (7d)
        </TableHead>
        <TableHead 
          className="font-semibold text-muted-foreground cursor-pointer hover:text-foreground"
          onClick={() => onSort("deploys_7days")}
        >
          Deploys (7d)
        </TableHead>
        <TableHead className="font-semibold text-muted-foreground text-right">Ações</TableHead>
      </TableRow>
    </TableHeader>
  );
}
